export default "__VITE_PUBLIC_ASSET__0bc5cc2e__"